import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { useDebouncedCallback } from 'use-debounce';
import { useAppEvent } from '../../../CodesThatsGottaGoSomewhereElse';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { useResolve } from '../../Container';
import { SortMode } from '../../common/Sorter';

export type BoardDataLocation = {
    workspaceId?: string,
    folderId?: string,
};

export const useInfiniteBoardData = (location: BoardDataLocation, search: string, sort: SortMode) => {
    // Only accept search if it's over 2 real chars
    search = search?.trim() || '';
    if (search.length < 2) search = '';

    const qc = useQueryClient();

    useAppEvent('board:create', useDebouncedCallback(() => qc.invalidateQueries(['boards.list']), 100));
    useAppEvent('board:patch', useDebouncedCallback(() => qc.invalidateQueries(['boards.list']), 500));
    useAppEvent('board:move', useDebouncedCallback(() => qc.invalidateQueries(['boards.list']), 500));
    useAppEvent('board:delete', useDebouncedCallback(() => qc.invalidateQueries(['boards.list']), 500));

    const api = useResolve(ApiClient);
    const params = {
        ...location,
        search,
        sort: sort.join(':'),
        offset: 0,
        limit: 32,
    };

    return useInfiniteQuery({
        keepPreviousData: true,
        queryKey: ['boards.list', JSON.stringify(params)],
        queryFn: async ({ pageParam }) => {
            const result = await api.exec(v2.boards.list2({ ...params, offset: pageParam || 0 }));
            return result;
        },
        getNextPageParam: (lastPage) => {
            const ll = lastPage.items.length || 0;
            if (!ll || ll < lastPage.limit) return undefined;
            return lastPage.offset + ll;
        },
    });
};
